import { getActionAuthorization } from '../commons/utils';

const INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE = {
  CLONE: 'inventory-list-template:clone',
  CREATE: 'inventory-list-template:create',
  DELETE: 'inventory-list-template:delete',
  EDIT: 'inventory-list-template:edit',
  VIEW: 'inventory-list-template:view',
};

export const canCloneInventoryListTemplateParams = (actions) =>
  getActionAuthorization(actions, INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE.CLONE);

export const canCreateInventoryListTemplate = (actions) =>
  getActionAuthorization(actions, INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE.CREATE);

export const canDeleteInventoryListTemplate = (actions) =>
  getActionAuthorization(actions, INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE.DELETE);

export const canEditInventoryListTemplate = (actions) =>
  getActionAuthorization(actions, INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE.EDIT);

export const canViewInventoryListTemplate = (actions) =>
  getActionAuthorization(actions, INVENTORY_LIST_TEMPLATE_ACTIONS_RESOURCE.VIEW);
